import { createStore as reduxCreateStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import reducers from "./reducers";

const createStore = () => reduxCreateStore(reducers, {}, composeWithDevTools());

export default createStore;
